import { render, staticRenderFns } from "./calcoloTest.vue?vue&type=template&id=f0f6a55a"
import script from "./calcoloTest.vue?vue&type=script&lang=js"
export * from "./calcoloTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports